import {FeatureFlagEnum, ModuleEnum} from 'src/api/ProactApiClient';
import useActiveFeatureFlags from 'src/shared/hooks/useActiveFeatureFlags';
import {useModulePermissions} from './useModulePermissions';

/**
 * Hook for AuditLog module permissions.
 * Combines permission checks with feature flag check - audit logs
 * are only accessible when the AuditLogs feature flag is enabled.
 */
export function useAuditLogPermissions() {
  const flags = useActiveFeatureFlags();
  const hasAuditLogFlag = flags.includes(FeatureFlagEnum.AuditLogs);
  const perms = useModulePermissions(ModuleEnum.AuditLog);

  return {
    view: perms.view && hasAuditLogFlag,
  };
}
